import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const ResetPasswordPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Card>
        <CardContent>
          <Typography variant="h4">Reset Password</Typography>
          <Typography>Reset password page - Coming soon</Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ResetPasswordPage;